import React, { memo, useMemo } from 'react'
import PropTypes from 'prop-types'

import { Collapsible } from 'Components'
import { _SimilarContainer, _SliderSection } from './styles'


export const GA_CATEGORY = 'RecommendedListings'

const RecommendedListings = (
  {
    mobileBrowser, title, seoText, similarListings,
    userIsAuthentificated, listingHomeType, offer, dataSource, googleAnalyticsEvent,
    listingTitle, gaSourcePage, collapsibleIdSuffix, isMobileApp,
  }) => {
  if(!similarListings || !similarListings.length) return ''
  const listings = similarListings
  const handleClick = () => {
    googleAnalyticsEvent({
      category: GA_CATEGORY,
      action: [
        'listing click',
        `from ${dataSource}`,
      ],
    })
  }
  const homeType = listingHomeType === 'Other' ? 'Listing' : listingHomeType
  const defaultSeoText = useMemo(() =>
    // eslint-disable-next-line max-len
    `Other ${homeType ? homeType.toLowerCase() : ''}s for ${(offer || 'Sale').toLowerCase()} similar to ${listingTitle}`,
  [offer, homeType, listingTitle],
  )
  const collapsibleSeoText = seoText || defaultSeoText
  return (
    <Collapsible
      inputId={`similarListings${collapsibleIdSuffix}`}
      title={title || 'Similar Listings'}
      seoText={collapsibleSeoText}
      isCollapsible={mobileBrowser}
    >
      <_SimilarContainer>
        <_SliderSection
          mobileBrowser={mobileBrowser}
          userIsAuthentificated={userIsAuthentificated}
          listings={listings}
          maxListingCount={4}
          handleClick={handleClick}
          dataSource={'backend'}
          gaCategory={'SimilarListings'}
          sourcePage={gaSourcePage}
          isMobileApp={isMobileApp}
          nearbyListingsOrSimilarListings
        />
      </_SimilarContainer>
    </Collapsible>

  )
}

RecommendedListings.propTypes = {
  listingHomeType: PropTypes.string,
  offer: PropTypes.string,
  title: PropTypes.string,
  listingTitle: PropTypes.string,
  similarListings: PropTypes.arrayOf(PropTypes.shape({})),
  mobileBrowser: PropTypes.bool,
  userIsAuthentificated: PropTypes.bool,
  seoText: PropTypes.string,
  dataSource: PropTypes.string,
  googleAnalyticsEvent: PropTypes.func,
  gaSourcePage: PropTypes.string,
  collapsibleIdSuffix: PropTypes.string,
  isMobileApp: PropTypes.bool,
}

export default memo(RecommendedListings)
